import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class MarketsService {

    constructor(private api: ApiService) {
    }

    getList() {
        return this.api.get('/admin/localizations').pipe(map(({result}) => result));
    }

    update(value) {
        return this.api.put('/admin/localizations', value).pipe(map(({result}) => result));
    }

    create(value) {
        return this.api.post('/admin/localizations', value).pipe(map(({result}) => result));
    }


    delete(localization) {
        if (localization) {
            return this.api.delete('/admin/localizations/' + localization.language).pipe(map(response => response));
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pages-services/markets.service.ts